<div class="chat-container" [class.expanded]="isExpanded" [class.fullscreen]="isFullscreen"
  [class.side-dialog-rtl]="isRTL">
  <mat-card class="chat-card" [class.fullscreen]="isFullscreen">
    <div class="chat-header">
      <div class="chat-header-left">
        <span class="chat-title">{{ 'CHAT_BOT.TITLE' | translate }}</span>
      </div>
      <div class="chat-actions">
        <button mat-icon-button
          [matTooltip]="(isChatHistoryDialogOpen ? 'CHAT_BOT.CLOSE_CHAT_HISTORY' : 'CHAT_BOT.CHAT_HISTORY') | translate"
          (click)="toggleChatHistoryDialog()">
          <mat-icon>history</mat-icon>
        </button>
        <!--        <button mat-icon-button-->
        <!--          [matTooltip]="(isVoiceDialogOpen ? 'CHAT_BOT.CLOSE_VOICE_SETTINGS' : 'CHAT_BOT.VOICE_SETTINGS') | translate"-->
        <!--          (click)="toggleVoiceSettingsDialog()">-->
        <!--          <mat-icon>settings_voice</mat-icon>-->
        <!--        </button>-->
        <button mat-icon-button [matTooltip]="'CHAT_BOT.NEW_CHAT' | translate" (click)="startNewChat()">
          <mat-icon>add</mat-icon>
        </button>
        <button mat-icon-button
          [matTooltip]="(isFullscreen ? 'CHAT_BOT.EXIT_FULLSCREEN' : 'CHAT_BOT.FULLSCREEN') | translate"
          (click)="toggleExpand()">
          <mat-icon>{{isFullscreen ? 'fullscreen_exit' : 'fullscreen'}}</mat-icon>
        </button>
        <button mat-icon-button [matTooltip]="'CHAT_BOT.CLOSE' | translate" (click)="toggleMinimize()">
          <mat-icon>close</mat-icon>
        </button>
      </div>
    </div>

    <div class="messages-container" #messagesContainer>
      <div *ngFor="let msg of messages" [class.user-message]="msg.isUser" [class.bot-message]="!msg.isUser"
        class="message">
        <div class="message-content" [class.being-edited]="msg.isEditing">
          <p>{{ msg.text }}</p>
          <div class="message-footer">
            <small class="timestamp">{{ msg.timestamp | date:'shortTime' }}</small>
            <div class="message-actions">
              <button mat-icon-button class="action-button copy-action" (click)="copyMessage(msg.text)"
                [matTooltip]="'CHAT_BOT.COPY_MESSAGE' | translate">
                <mat-icon>content_copy</mat-icon>
              </button>
              <button *ngIf="!msg.isUser" mat-icon-button class="action-button play-stop-action"
                [class.playing]="msg.isPlaying" (click)="togglePlayMessage(msg)"
                [matTooltip]="(msg.isPlaying ? 'CHAT_BOT.STOP_MESSAGE' : 'CHAT_BOT.PLAY_MESSAGE') | translate">
                <mat-icon>{{msg.isPlaying ? 'stop' : 'play_arrow'}}</mat-icon>
              </button>
              <button *ngIf="msg.isUser && isLastUserMessage(msg)" mat-icon-button class="action-button edit-action"
                [class.active]="msg.isEditing" (click)="startEditMessage(msg)"
                [matTooltip]="'CHAT_BOT.EDIT_MESSAGE' | translate">
                <mat-icon>edit</mat-icon>
              </button>
            </div>
          </div>
        </div>

        <div *ngIf="!msg.isUser && messages[0] === msg" class="suggested-services-container">
          <div class="suggested-services-grid">
            <ng-container *ngFor="let service of allServices">
              <button mat-stroked-button (click)="selectService(service.text)" color="primary">
                <mat-icon>{{service.icon}}</mat-icon>
                <span>{{ service.text }}</span>
              </button>
            </ng-container>
            <ng-container *ngFor="let service of allServices">
              <button mat-stroked-button (click)="selectService(service.text)" color="primary">
                <mat-icon>{{service.icon}}</mat-icon>
                <span>{{ service.text }}</span>
              </button>
            </ng-container>
          </div>
        </div>
      </div>
    </div>

    <div class="input-container" [class.expanded]="isInputExpanded">
      <div class="input-header" *ngIf="isInputExpanded">
        <span>{{ 'CHAT_BOT.MESSAGE' | translate }}</span>
        <div class="header-actions">
          <button mat-icon-button (click)="attachFile()" [matTooltip]="'CHAT_BOT.ATTACH_FILE' | translate">
            <mat-icon>attach_file</mat-icon>
          </button>
          <button mat-icon-button (click)="startVoiceChat()" [matTooltip]="'CHAT_BOT.VOICE_INPUT' | translate">
            <mat-icon>mic</mat-icon>
          </button>
          <button mat-icon-button (click)="toggleInputExpand()" [matTooltip]="'CHAT_BOT.MINIMIZE' | translate">
            <mat-icon>close_fullscreen</mat-icon>
          </button>
        </div>
      </div>

      <div *ngIf="isVoiceDialogOpens" class="inline-language-dialog">
        <mat-label>{{ 'COMMON.SELECT_LANGUAGE' | translate }}</mat-label>
        <mat-radio-group [(ngModel)]="selectedLang" name="languageSelection"
          style="display: flex; flex-direction: column; gap: 8px; margin-top: 8px;">
          <mat-radio-button value="ar-EG">عربي</mat-radio-button>
          <mat-radio-button value="en-US">English (US)</mat-radio-button>
        </mat-radio-group>
        <div class="dialog-actions">
          <button mat-button (click)="cancelLanguageSelection()">{{ 'COMMON.CANCEL' | translate }}</button>
          <button style="background-color: #3B185F ; color: #FFFFFF" mat-raised-button
            (click)="confirmLanguageSelection()">{{ 'COMMON.START' | translate }}</button>
        </div>
      </div>

      <div class="edit-mode-banner" *ngIf="editingMessage">
        <mat-icon class="edit-mode-icon">edit</mat-icon>
        <span class="edit-mode-text">{{ 'CHAT_BOT.EDITING_MESSAGE' | translate }}</span>
        <button mat-icon-button class="edit-mode-cancel" (click)="cancelEditMessage()"
          [matTooltip]="'CHAT_BOT.CANCEL_EDIT' | translate">
          <mat-icon>close</mat-icon>
        </button>
      </div>

      <mat-form-field appearance="outline" class="message-input" [class.expanded]="isInputExpanded">
        <div class="input-resize-handle" *ngIf="!isInputExpanded" (pointerdown)="startInputResize($event)"
          [matTooltip]="'CHAT_BOT.RESIZE_INPUT' | translate">
          <mat-icon>drag_handle</mat-icon>
        </div>
        <textarea matInput [(ngModel)]="message" [placeholder]="'CHAT_BOT.TYPE_MESSAGE' | translate"
          [rows]="isInputExpanded ? 8 : 4" (keyup.enter)="sendMessage()"></textarea>
        <button *ngIf="!isFullscreen && !isInputExpanded" mat-icon-button class="expand-button"
          (click)="toggleInputExpand()">
          <mat-icon>open_in_full</mat-icon>
        </button>
        <button *ngIf="isFullscreen && !isInputExpanded" mat-icon-button class="expand-button"
          (click)="toggleInputExpand()" [matTooltip]="'CHAT_BOT.EXPAND_INPUT' | translate">
          <mat-icon>vertical_align_top</mat-icon>
        </button>

        <div class="inline-input-actions">
          <button class="inline-action-button voice-button" [class.recording]="isRecording" mat-icon-button
            [matTooltip]="(isVoiceDialogOpens ? 'CHAT_BOT.CLOSE_VOICE_SETTINGS' : 'CHAT_BOT.VOICE_SETTINGS') | translate"
            (click)="toggleVoiceSettings()">
            <mat-icon>settings_voice</mat-icon>
          </button>

          <button class="inline-action-button send-button" mat-icon-button color="primary" (click)="sendMessage()"
            [matTooltip]="(editingMessage ? 'CHAT_BOT.UPDATE_MESSAGE' : 'CHAT_BOT.SEND_MESSAGE') | translate">
            <mat-icon>{{ editingMessage ? 'check' : 'send' }}</mat-icon>
          </button>
        </div>
      </mat-form-field>





      <div class="input-actions">
        <button mat-icon-button (click)="attachFile()" [matTooltip]="'CHAT_BOT.ATTACH_FILE' | translate">
          <mat-icon>attach_file</mat-icon>
        </button>
        <button mat-icon-button (click)="startVoiceChat()" [matTooltip]="'CHAT_BOT.VOICE_INPUT' | translate">
          <mat-icon>mic</mat-icon>
        </button>
        <!--        <button mat-icon-button color="primary" (click)="sendMessage()"-->
        <!--          [matTooltip]="'CHAT_BOT.SEND_MESSAGE' | translate">-->
        <!--          <mat-icon>send</mat-icon>-->
        <!--        </button>-->
      </div>
    </div>
  </mat-card>
</div>

<div class="chat-backdrop" (click)="toggleMinimize()"></div>